module.exports = __webpack_public_path__ + "static/media/06.be492f40.jpg";